type WishlistAlternative = {
  item?: number
  item_level?: number
  percentage?: number
  absolute?: number
}

type Props = {
  alternative: WishlistAlternative
  valueDisplay?: string
}

const baseWowheadUrl = `https://wowhead.com/`

const formatAlternativeValue = (
  alternative: WishlistAlternative,
  valueDisplay: string,
) => {
  if (valueDisplay === 'percentage') {
    return `${(alternative.percentage ?? 0).toLocaleString('en-US', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })}%`
  }

  return `${(alternative.absolute ?? 0).toLocaleString('en-US', {
    maximumFractionDigits: 0,
  })} value`
}

const WishlistAlternativeTooltipContent = ({
  alternative,
  valueDisplay = 'percentage',
}: Props) => (
  <div className='text-xs max-w-60'>
    There is a {formatAlternativeValue(alternative, valueDisplay)}{' '}
    <a
      target='_blank'
      rel='noreferrer'
      className='text-primary hover:text-primary/90'
      href={`${baseWowheadUrl}item=${alternative.item}${
        typeof alternative.item_level === 'number'
          ? `?ilvl=${alternative.item_level}`
          : ''
      }`}
    >
      upgrade
    </a>{' '}
    that is better in this slot than this item.
  </div>
)

export type { WishlistAlternative }
export default WishlistAlternativeTooltipContent
